import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import OrderStaticTableCell from './OrderStaticTableCell';

const OrderStaticsHeadquerterRows = ({ data, headerRows }) => {
  if (Array.isArray(data) && data.length === 0) {
    return <Box>데이터가 없습니다.</Box>;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return (
        <TableRow key={hIndex}>
          <TableCell align="center" sx={{ width: 150 }}>
            {hq.name}
          </TableCell>
          <OrderStaticTableCell data={hq} headerRows={headerRows} />
        </TableRow>
      );
    })
  );
};

export default OrderStaticsHeadquerterRows;
